// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PasswordRecoveryChangeRequest extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_RECOVERY_CHANGE_REQUEST, fieldSet);
    }
    setPassword(password) {
        this.setFieldValue(FieldsFactory.FIELD_PASSWORD, password);
    }
    setLogin(login) {
        this.setFieldValue(FieldsFactory.FIELD_LOGIN, login);
    }
    setKey(key) {
        this.setFieldValue(FieldsFactory.FIELD_KEY, key);
    }
    setAccessToken(accessToken) {
        this.setFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN, accessToken);
    }
}
